import { useMutation, useQueryClient } from '@tanstack/react-query';

import { generateData } from '../client';
import { useSimulationId } from './useSimulationId';

export interface GenerateDataInput {
  nTeams: number;
  nFeatures: number;
  maxEffort: number;
  minTasksPerFeature: number;
  maxTasksPerFeature: number;
  seed: string; // empty string → null (random)
}

export function useGenerateData() {
  const queryClient = useQueryClient();
  const simId = useSimulationId();

  const mutation = useMutation({
    mutationFn: async (input: GenerateDataInput) => {
      await generateData({
        body: {
          simulation_id: simId,
          n_teams: input.nTeams,
          n_features: input.nFeatures,
          max_effort: input.maxEffort,
          min_tasks_per_feature: input.minTasksPerFeature,
          max_tasks_per_feature: input.maxTasksPerFeature,
          seed: input.seed ? Number(input.seed) : null,
        },
        throwOnError: true,
      });
    },
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ['dashboardData'] });
      queryClient.removeQueries({ queryKey: ['features-with-team-context'] });
      queryClient.removeQueries({ queryKey: ['features'] });
      queryClient.removeQueries({ queryKey: ['team-tasks'] });
      queryClient.removeQueries({ queryKey: ['task'] });
      queryClient.invalidateQueries();
    },
  });

  return mutation;
}
